import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const CSA_ICON_SIZE = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const CSA_ICON_MARGIN = {
  [HD]: 8,
  [FULL_HD]: 8,
};
